import { render, staticRenderFns } from "./AssignmentForm.vue?vue&type=template&id=2bc7ac66&scoped=true&"
import script from "./AssignmentForm.vue?vue&type=script&lang=js&"
export * from "./AssignmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentForm.vue?vue&type=style&index=0&id=2bc7ac66&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc7ac66",
  null
  
)

export default component.exports